// Outbound half of URL-as-state for the menu editor: reflect the current
// selection into ?menuid=&categoryid=&productid=, touching only those three
// keys so action params (review, optiongroupid) and future params survive.
export const buildSelectionParams = (searchParams, selected) => {
  const next = new URLSearchParams(searchParams);
  const entries = {
    menuid: selected.menuid || null,
    categoryid: selected.category?.id || null,
    productid: selected.product?.id || null,
  };
  Object.entries(entries).forEach(([key, value]) => {
    if (value) next.set(key, value);
    else next.delete(key);
  });
  return next;
};
